const cameraHandler      = require ('./camera-handler')


/****************ELEMENTS*****************/
var scrimCamera
var HTMLwasSelected = false

function HTMLselect(){ //console.log('HTMLselect')

    HTMLwasSelected  = true
}

/****************ELEMENTS*****************/


export function start(detail){ //console.log('Quickform START>', detail.act)
    scrimCamera  = document.getElementById('scrim_quickform')
    if(!HTMLwasSelected) { HTMLselect() }
     
    obj[detail.act].start(detail)

}/**/



const obj = {
 
    startCamera:         { start: (detail)=>{  cameraHandler.startCamera(detail)     }},
    photo:         { start: (detail)=>{  cameraHandler.photo(detail)     }},
    savePreview:         { start: (detail)=>{  cameraHandler.savePreview(detail)     }},
    cancelPreview:         { start: (detail)=>{  cameraHandler.cancelPreview(detail)     }},
    stopCamera: { start: detail => cameraHandler.stopCamera(detail) },

}